document.addEventListener 'turbolinks:load', ->
  $('.js-lettering').lettering()
